import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import './Legal.css';

const Privacy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="header-content">
          <button onClick={() => navigate(-1)} className="back-button">
            ← Back
          </button>
          <div className="brand-logo" onClick={() => navigate('/')}>
            <Logo height={34} />
          </div>
        </div>
      </header>

      <main className="legal-main">
        <article className="legal-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: December 2024</p>

          <section>
            <h2>Introduction</h2>
            <p>
              Lomi ("we," "our," or "us") is committed to protecting your privacy.
              This Privacy Policy explains how we collect, use, and safeguard your
              information when you use our AI-powered tutoring platform.
            </p>
            <p>
              Lomi is built in Ethiopia, for Ethiopian students.
            </p>
          </section>

          <section>
            <h2>Information We Collect</h2>

            <h3>Information You Provide</h3>
            <ul>
              <li><strong>Account Information:</strong> Phone number, name, grade level, and academic stream (Natural/Social Sciences)</li>
              <li><strong>Learning Data:</strong> Your answers to questions, quiz results, and learning progress</li>
              <li><strong>Communications:</strong> Questions you ask Lomi AI and feedback you provide</li>
            </ul>

            <h3>Information Collected Automatically</h3>
            <ul>
              <li><strong>Usage Data:</strong> How you interact with Lomi, including time spent on lessons, modules completed, and features used</li>
              <li><strong>Device Information:</strong> Device type, operating system, and browser type</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <ul>
              <li><strong>Personalization:</strong> To adapt lessons and recommendations to your learning needs</li>
              <li><strong>Improvement:</strong> To improve our AI tutoring and content quality</li>
              <li><strong>Communication:</strong> To send important updates about your account and learning progress</li>
              <li><strong>Research:</strong> To analyze aggregate learning patterns (anonymized) to improve Ethiopian education outcomes</li>
            </ul>
          </section>

          <section>
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information.
              Your learning data is encrypted and stored securely. We do not sell your
              personal information to third parties.
            </p>
          </section>

          <section>
            <h2>Data Retention</h2>
            <p>
              We retain your account and learning data for as long as your account is active.
              You can request deletion of your account and associated data at any time by
              contacting us.
            </p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Export your learning progress</li>
            </ul>
          </section>

          <section>
            <h2>Children's Privacy</h2>
            <p>
              Lomi is designed for students preparing for the ESSLCE and the AAU UAT, typically ages 16 and above.
              We do not knowingly collect information from children under 13 without parental consent.
            </p>
          </section>

          <section>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of
              any significant changes through the app or via your registered phone number.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or your data, please contact us:
            </p>
            <ul>
              <li>Email: <a href="mailto:info@lomistudy.com">info@lomistudy.com</a></li>
              <li>Location: Addis Ababa, Ethiopia</li>
            </ul>
          </section>
        </article>
      </main>

      <footer className="legal-footer">
        <div className="footer-brand">
          <Logo height={28} />
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
